import { render } from "./StaticNatModal.vue?vue&type=template&id=56042161&scoped=true"
import script from "./StaticNatModal.vue?vue&type=script&lang=js"
export * from "./StaticNatModal.vue?vue&type=script&lang=js"

import "./StaticNatModal.vue?vue&type=style&index=0&id=56042161&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-user-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56042161"]])

export default __exports__